module.exports = __webpack_public_path__ + "img/KarimGuettai_140x140_rund.c8962f05.jpg";